import script from "./AppFaceTool.vue?vue&type=script&setup=true&lang=js"
export * from "./AppFaceTool.vue?vue&type=script&setup=true&lang=js"

import "./AppFaceTool.vue?vue&type=style&index=0&id=3e2a2924&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e2a2924"]])

export default __exports__